var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary w-100",
          attrs: { disabled: _vm.disabled },
          on: { click: _vm.openMediaPicker }
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("maintenance.overview2d.selectMedia")) +
              "\n  "
          )
        ]
      ),
      _vm._v(" "),
      _c("MediaPicker", {
        ref: "mediaPicker",
        on: { selected: _vm.onSelected }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }